export const base_route = '/dwo-api-application/v1/deeplink/vippsgateway';

export const Routes = {
  ERROR: 0,
  STATUS: 1,
  TIMEOUT: 2,
  LANDING: 3,
} as const;
export type Routes = (typeof Routes)[keyof typeof Routes];

export const RouteNames: Record<Routes, string> = {
  [Routes.ERROR]: 'error',
  [Routes.STATUS]: 'status',
  [Routes.TIMEOUT]: 'timeout',
  [Routes.LANDING]: 'landing',
};
